interface Corner {
    conciergePanelVisible: boolean;
    widgetWidth: number;
    floatingButtonVisible: boolean;
    inputToastRightClearance: number;
}

// The prompt is fixed to the bottom-right corner and yields to whatever else
// is anchored there; null keeps the stylesheet's default offset.
export function ratingPromptRight({
    conciergePanelVisible,
    widgetWidth,
    floatingButtonVisible,
    inputToastRightClearance,
}: Corner): string | null {
    if (conciergePanelVisible) return `${widgetWidth + 20}px`;
    if (inputToastRightClearance > 0) return `${inputToastRightClearance}px`;
    if (floatingButtonVisible) return '80px';
    return null;
}
